<template>
  <section id="dashboard" class="page-content">
      <main id="section-body">
        <div class="columns is-desktop is-gapless" style="margin-bottom:0px">
          <div class="column columns is-tablet">
            <a class="column dashtag-column"><!-- :to="{path: `/shipments/?last_n_days=7`}" -->
              <dashtag
              @clickBanner="selectTab(0)"
              color="primary"
              :addClass="selectedTab==0? 'selected' : 'non-selected'"
              heading="shipments last week"
              :title="stats.shipments_last_week_count"
              @save="saveUser()"
              />
            </a>
            <a class="column dashtag-column"> <!-- :to="{path: '/shipments/?health=ontrack'}" -->
              <dashtag
              @clickBanner="selectTab(1)"
              color="success"
              :addClass="selectedTab==1? 'selected' : 'non-selected'"
              :title="stats.shipments_on_track_count"
              heading="on track"
              />
            </a>
          </div>
          <div class="column columns is-tablet">
            <a class="column dashtag-column"> <!-- :to="{path: '/shipments/?health=delayed'}" -->
              <dashtag
              @clickBanner="selectTab(2)"
              color="warning"
              :addClass="selectedTab==2? 'selected' : 'non-selected'"
              :config="true"
              :title="stats.shipments_delayed_count"
              heading="out of date"
              @save="saveUser()"
              >
              <div slot="modal" style="max-height:350px; overflow-y: auto">
                <table style="width:100%; table-layout:fixed">
                  <tr>
                    <td style="text-align:center">ETD at POL or ETA at POD delay >=</td>
                  </tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Delayed days" v-model.number="userInfo.userprofile.days_of_delay"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">ETD at POL or ETA at POD advance >=</td>
                  </tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Advanced days" v-model.number="userInfo.userprofile.days_in_advance"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Discrepancy ETA at POD</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Contractual ETA at POD discrepancy days" v-model.number="userInfo.userprofile.max_days_eta_pod_discrepancy"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Discrepancy ETA at DLV</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Contractual ETA at DLV discrepancy days" v-model.number="userInfo.userprofile.max_days_eta_dlv_discrepancy"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days in TSP</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days in TSP" v-model.number="userInfo.userprofile.max_days_in_tsp"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days in TSP Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days in TSP Planned" v-model.number="userInfo.userprofile.max_days_in_tsp_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days in POL</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days in POL" v-model.number="userInfo.userprofile.max_days_in_pol"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days in POL Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days in POL Planned" v-model.number="userInfo.userprofile.max_days_in_pol_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days in POD</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days in POD" v-model.number="userInfo.userprofile.max_days_in_pod"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days in POD Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days in POD Planned" v-model.number="userInfo.userprofile.max_days_in_pod_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max storage days at POL</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max storage days at POL" v-model.number="userInfo.userprofile.max_storage_days_at_pol"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max storage days at POL Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max storage days at POL Planned" v-model.number="userInfo.userprofile.max_storage_days_at_pol_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max storage days at POD</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max storage days at POD" v-model.number="userInfo.userprofile.max_storage_days_at_pod"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max storage days at POD Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max storage days at POD Planned" v-model.number="userInfo.userprofile.max_storage_days_at_pod_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days between Empty Return and POD</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days between Empty Return and POD" v-model.number="userInfo.userprofile.max_days_between_empty_return_and_pod"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days between Empty Return and POD Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days between Empty Return and POD Planned" v-model.number="userInfo.userprofile.max_days_between_empty_return_and_pod_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days between Empty Return and LIF</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days between Empty Return and LIF" v-model.number="userInfo.userprofile.max_days_between_empty_return_and_lif"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">Max days between Empty Return and LIF Planned</td></tr>
                  <tr>
                    <td style="padding:0 10px"><input class="input" type="number" min="1" placeholder="Max days between Empty Return and LIF Planned" v-model.number="userInfo.userprofile.max_days_between_empty_return_and_lif_planned"></td>
                  </tr>
                  <tr>
                    <td style="text-align:center">POD Time of Arrival Risk</td></tr>
                  <tr>
                    <td style="padding:0 10px">
                      <div class="select">
                        <select placeholder="Choose Risk" v-model="userInfo.userprofile.pod_timeofarrival_warning_risk">
                          <option :value="null">------</option>
                          <option v-for="risk in podTimeOfArrivalWarningRisk" :key="risk.value" :value="risk.value">{{ risk.label }}</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              </dashtag>
            </a>
            <!-- <router-link class="column" :to="{path: '/shipments/?health=delayed'}">
              <banner
              color="warning"
              fa-icon="fa-clock-o"
              :title="stats.shipments_warning_count"
              heading="warning"
              />
            </router-link> -->
            <a class="column dashtag-column"> <!-- :to="{path: '/shipments/?health=alerted'}" -->
              <dashtag
               @clickBanner="selectTab(3)"
              color="danger"
              :addClass="selectedTab==3? 'selected' : 'non-selected'"
              :title="stats.shipments_with_incidents_count"
              :config="true"
              heading="attention required"
              @save="saveUser()"
              >
              <div slot="modal">
                <ul style="max-height:350px; overflow-y: auto">
                  <li v-for="eventCode in eventCodes" :key="eventCode.code" >
                     <label class="checkBox" :for="eventCode.code" v-on:click.capture.stop>
                        <input type="checkbox" :id="eventCode.code" :value='eventCode.code' v-model="userInfo.userprofile.attention_required_event_codes">
                        <span class="checkmark"/>
                          {{eventCode.description}}
                      </label>
                  </li>
                </ul>
              </div>
              </dashtag>
            </a>
          </div>
        </div>
          <span class="table-container" :style="{'border-color': tabStyles[selectedTab].color}">
            <spinner :notFullScreen="true" v-show="loadingTable"></spinner>
            <div v-show="!loadingTable">
              <data-table
                url="shipment"
                :title="'Shipments ' + tabStyles[selectedTab].name"
                :titleStyle="'text-transform:uppercase;font-family: MuseoSans-700; color:' + tabStyles[selectedTab].color"
                :objects="objects"
                :schema="schema"
                :totalItems="count"
                :fields="tableHeaders"
                :alias="{
                    'status_verbose': 'status',
                    'container_type_str': 'Container Type',
                    'last_alert_code': 'Last Event',
                    'pod_timeofarrival_warning': 'POD Arrival Risk',
                    'bl_or_booking_number': 'BL / Booking',
                    'client_code': 'Client Code',
                    'carrier_name': 'Carrier',
                    'pol_loc': 'POL',
                    'pod_loc': 'POD',
                    'etd': 'ETD',
                    'atd': 'ATD',
                    'dtd': 'DTD',
                    'eta': 'ETA',
                    'ata': 'ATA',
                    'dta': 'DTA',
                    'storage_days_at_pol': 'Storage days at POL',
                    'storage_days_at_pod': 'Storage days at POD',
                    'discrepancy_eta_at_pod': 'DTAcP',
                    'discrepancy_eta_at_dlv': 'DTAcD',
                    'days_in_tsp': 'DTSP',
                    'days_in_tsp_planned_initial': 'DTSP Planned Initial',
                    'days_in_pod_planned_initial': 'DPOD Planned Initial',
                    'days_in_pol_planned_initial': 'DPOL Planned Initial',
                    'days_in_tsp_planned_last': 'DTSP Planned Initial',
                    'days_in_pod_planned_last': 'DPOD Planned Initial',
                    'days_in_pol_planned_last': 'DPOL Planned Initial',
                    'created_at': 'Created',
                    'sf_data': 'C. Form'
                }"
                :mappers="{'health': HEALTH}"
                :tooltips="{
                  'last_alert_code': 'last_alert_message',
                  'sf_data': 'sf_data',
                  'pod_timeofarrival_warning': 'pod_timeofarrival_warning_tooltip'
                }"
                :modalFields="['last_alert_code']"
                @modal="openLastEvents($event)"
              >
                <template slot="pod_timeofarrival_warning" slot-scope="scope">
                  <span style="white-space: nowrap">
                    <i :class="getRiskIcon(scope.obj.value)" />
                    {{scope.obj.formated}}
                  </span>
                </template>
                <template slot="health" slot-scope="scope">
                  <span class="status-tag" :class="scope.obj.value">{{scope.obj.formated}}</span>
                </template>
              </data-table>
            </div>
          </span>
          <pagination
            :currentPage.sync="page"
            :totalItems="count"
            :itemsPerPage="pageSize"
          />
          <modal v-if="showLastEvents" @close="closeEvents()" width="95%">
            <h3 slot="header" style="font-size:2em">Last Alert Events</h3>
            <div slot="body">
              <table class="table is-fullwidth is-striped is-bordered is-hoverable">
                <thead>
                  <th id="data-table-header">Code</th>
                  <th id="data-table-header">Message</th>
                  <th id="data-table-header">WallTime</th>
                  <th id="data-table-header">Hidden</th>
                </thead>
                <tbody>
                  <tr class="object" v-for="event in lastEvents" :key="event.id">
                    <td>{{event.code_description}}</td>
                    <td>{{event.details.message}}</td>
                    <td>{{event.walltime}}</td>
                    <td style="text-align:center">
                      <input type="checkbox" v-model="event.hidden" @change="saveEvent(event)"/>
                      <span class="checkmark"/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </modal>
      </main>
  </section>
</template>
<script>
import {mapActions, mapState, mapGetters} from 'vuex'

import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import Dashtag from '@/components/Dashtag'
import DataTable from '@/components/DataTable'
import Spinner from '@/components/Spinner'
import Pagination from '@/components/Pagination'
import Modal from '@/components/Modal'

import Shipment from '@/models/shipment'
import moment from 'moment'

export default {
  name: 'dashboard',
  props: ['_userInfo'],
  components: {Dashtag, DataTable, Spinner, Pagination, Modal},
  mixins: [PaginatedFilteredListMixin],
  mounted () {
    this.$emit('loading')
    this.loadHeaders()
    this.filters = {last_n_days: 7}
    this.filterOpt = [{last_n_days: 7}, {health: 'ontrack'}, {health: 'delayed'}, {health: 'alerted'}]
    this.page = 1
    const promises = [
      this.getCarriers().then(response => { this.carriers = response }),
      this.getStats().then(response => { this.stats = response }),
      this.getCodeTypes().then(response => { this.codeTypes = response }),
      this.getPage(this.page),
      this.getEventCodes().then(response => { this.eventCodes = response }),
      this.fillUser().then()
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  computed: {
    ...mapState({
      pageSize: state => state.pageSize,
      count: state => state.shipment.count
    }),
    ...mapGetters({hasPermission: 'hasPermission'}),
    today () {
      return this.dateToString(new Date())
    },
    lastWeek () {
      var today = new Date()
      var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7)
      return this.dateToString(lastWeek)
    }
  },
  watch: {
    _userInfo () { this.userInfo = this._userInfo },
    'page' () { this.getPage(this.page) }
  },
  data () {
    return {
      tableHeaders: [
        'id',
        'status_verbose',
        'health',
        'last_alert_code',
        'pod_timeofarrival_warning',
        'container_number',
        'bl_or_booking_number',
        'client_code',
        'carrier_name',
        'pol_loc',
        'pod_loc',
        'etd',
        'atd',
        'dtd',
        'eta',
        'ata',
        'dta',
        'discrepancy_eta_at_pod',
        'discrepancy_eta_at_dlv',
        'days_in_tsp',
        'storage_days_at_pol',
        'storage_days_at_pod',
        'sf_data',
        'last_update',
        'created_at'
      ],
      page: 1,
      schema: Shipment.schema(),
      HEALTH: Shipment.HEALTH,
      STATUS_FILTER: Shipment.STATUS_FILTER,

      objects: [],
      carriers: [],
      loadingTable: false,
      lastEvents: [],
      tabStyles: [{name: 'Last Week', color: '#006A65'}, {name: 'On Track', color: '#2B957A'}, {name: 'Out of Date', color: '#F77600'}, {name: 'Atention Required', color: '#EC2121'}, {}],

      /* schema: TrackingRequest.schema(),
      STATUS: TrackingRequest.STATUS,
      SHIPMENTS_HEALTH: TrackingRequest.SHIPMENTS_HEALTH, */
      stats: {},
      codeTypes: {},
      trackingRequests: [],
      eventCodes: [],
      selectedEventCodes: [],
      userInfo: {userprofile: {days_of_delay: 1, days_in_advance: 1, attention_required_event_codes: []}},
      selectedTab: 0,
      filterOpt: [],
      filters: {},
      showLastEvents: false,
      shipment: 0,
      podTimeOfArrivalWarningRisk: [
//        {'label': 'Unknown', 'value': -1},
//        {'label': 'No Risk', 'value': 0},
        {'label': 'Low', 'value': 1},
        {'label': 'High', 'value': 2}
      ]
    }
  },
  methods: {
    ...mapActions({
      getCodeTypes: 'codeType/list',
      getStats: 'stats/retrieve',
      getEventCodes: 'eventCode/list',
      getUserInfo: 'user/read',
      saveUserInfo: 'user/save',
      getCarriers: 'carrier/list',
      getObjects: 'shipment/list',
      getLastEvents: 'shipment/lastEvents',
      hideLastEvents: 'shipment/hideEvent',
      unhideLastEvents: 'shipment/unhideEvent'
    }),
    getRiskIcon (risk) {
      if (!risk.__str__) return ''
      if (risk.risk === '0') { return 'fa fa-lg fa-thumbs-up green' }
      if (risk.risk === '-1') { return 'fa fa-lg fa-question blue' }
      if (risk.risk === '1') { return 'fa fa-lg fa-exclamation orange' }
      if (risk.risk === '2') { return 'fa fa-lg fa-exclamation-triangle red' }
    },
    selectTab (tab) {
      if (this.selectedTab !== tab) {
        this.loadingTable = true
        this.page = 1
        this.filters = this.filterOpt[tab]
        this.getPage(this.page).then(
          response => {
            this.loadingTable = false
            this.selectedTab = tab
          }
        )
      }
    },
    dateToString (value) {
      let dateString = moment(value).format('YYYY-MM-DD')
      return value ? dateString : null
    },
    saveUser () {
      this.loadingTable = true
      var userInfo = Object.assign({}, this.userInfo)

      if (!userInfo.userprofile.days_of_delay) {
        userInfo.userprofile.days_of_delay = null
      }

      if (!userInfo.userprofile.days_in_advance) {
        userInfo.userprofile.days_in_advance = null
      }

      if (!userInfo.userprofile.max_days_in_tsp) {
        userInfo.userprofile.max_days_in_tsp = null
      }

      if (!userInfo.userprofile.max_days_in_pol) {
        userInfo.userprofile.max_days_in_pol = null
      }

      if (!userInfo.userprofile.max_days_in_pod) {
        userInfo.userprofile.max_days_in_pod = null
      }

      if (!userInfo.userprofile.max_days_in_tsp_planned) {
        userInfo.userprofile.max_days_in_tsp_planned = null
      }

      if (!userInfo.userprofile.max_days_in_pol_planned) {
        userInfo.userprofile.max_days_in_pol_planned = null
      }

      if (!userInfo.userprofile.max_storage_days_at_pol) {
        userInfo.userprofile.max_storage_days_at_pol = null
      }

      if (!userInfo.userprofile.max_storage_days_at_pod) {
        userInfo.userprofile.max_storage_days_at_pod = null
      }

      if (!userInfo.userprofile.max_storage_days_at_pol_planned) {
        userInfo.userprofile.max_storage_days_at_pol_planned = null
      }

      if (!userInfo.userprofile.max_storage_days_at_pod_planned) {
        userInfo.userprofile.max_storage_days_at_pod_planned = null
      }

      if (!userInfo.userprofile.max_days_eta_dlv_discrepancy) {
        userInfo.userprofile.max_days_eta_dlv_discrepancy = null
      }

      if (!userInfo.userprofile.max_days_eta_pod_discrepancy) {
        userInfo.userprofile.max_days_eta_pod_discrepancy = null
      }

      this.saveUserInfo(userInfo).then(response => {
        this.page = 1
        this.filters = this.filterOpt[this.selectedTab]
        var promises = [
          this.getPage(this.page).then(
            response => {
              this.trackingRequests = response
            }
          ),
          this.getStats().then(response => { this.stats = response }),
          this.getUserInfo().then(response => {
            this.userInfo = response
          })
        ]
        Promise.all(promises).then(data => { this.loadingTable = false })
      })
    },
    loadHeaders () {
      if (this.userInfo && this.userInfo.userprofile && this.userInfo.userprofile.shipments_fields) {
        this.tableHeaders = this.userInfo.userprofile.shipments_fields
      }
    },
    openLastEvents (row) {
      this.shipment = row.id
      this.getLastEvents(row.id).then((response) => {
        this.lastEvents = response
      })
      this.showLastEvents = true
    },
    saveEvent (event) {
      if (event.hidden) {
        this.hideLastEvents(event.id).then((response) => {
        })
      } else {
        this.unhideLastEvents(event.id).then((response) => {
        })
      }
    },
    closeEvents () {
      this.loadingTable = true
      var promises = [
        this.getStats().then(response => { this.stats = response }),
        this.getPage(this.page).then(
          response => {
            this.trackingRequests = response
          }
        )
      ]
      Promise.all(promises).then(() => {
        this.loadingTable = false
      })
      this.showLastEvents = false
    },
    fillUser () {
      return this.getUserInfo().then(response => {
        this.userInfo = response
        if (this.userInfo.userprofile.days_in_advance) {
          this.userInfo.userprofile.days_in_advance = -1 * Math.abs(this.userInfo.userprofile.days_in_advance)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../node_modules/bulma/sass/utilities/initial-variables.sass';
  #dashboard #section-body .columns{
    @media screen and (min-width: $tablet) {
      &.is-desktop{ height: 260px }
      &.is-tablet{ height: 130px }
    }
    @media screen and (min-width: $desktop) {
      &.is-desktop{
        height: 130px;
        .columns {
          min-width: 450px;
          max-width: 30%;
        }
      }
    }
    .column div{
      height: 100%;
    }
  }
  .non-selected {
    padding-bottom: 1.5rem;
    box-sizing: border-box;
  }
  .selected div{
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .data-table.card{
    margin-top: 0;
  }
  #data-table-header{
    font-weight: bold;
  }
  .red {
    color: #e73857;
  }
  .orange {
    color: #ffb346
  }
  .blue {
    color: #1ca7d1;
  }
  .green {
    color: #90be6f;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageDashboard.vue